<template>
  <div class="payment-layout">
    <div v-if="userId == null" class="check-login">
      <ChecklLogin />
    </div>
    <div v-else>
      {{ $route.name }}
    </div>
  </div>
</template>

<script>
import ChecklLogin from "../components/CheckLogin.vue"

export default {
  name: "Contact",
  components: {
    ChecklLogin
  },
  data() {
    return {
      userId: null,
    }
  },
  methods: {
    async fetchData() {
      this.userId = localStorage.getItem('user_id');
    }
  },
  created() {
    this.fetchData();
  },
}
</script>

<style scoped>
.payment-layout {
  padding: 8px;
}
</style>

<!-- 
<template>
  <div>
    <img v-bind:src="currentImage" />
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      image1: require('../assets/Group 157.png'),
      image2: require('../assets/Group 158.png'),
      isImage1Visible: true,
    };
  },
  computed: {
    currentImage() {
      return this.isImage1Visible ? this.image1 : this.image2;
    },
  },
  mounted() {
    setInterval(() => {
      this.isImage1Visible = !this.isImage1Visible;
    }, 1500);
  },
};
</script> -->
